/** Palette d’accent — mêmes 12 teintes que Coffre / Mail. */

export const FX_ACCENT_IDS = [
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "pink",
  "slate",
  "teal",
  "indigo",
  "fuchsia",
  "lime",
] as const;

export type FxAccentId = (typeof FX_ACCENT_IDS)[number];

export type FxAccent = {
  id: FxAccentId;
  label: string;
  swatch: string;
  accent: string;
  accentStrong: string;
  accentSoft: string;
  accentSoftDark: string;
};

export const FX_ACCENTS: Record<FxAccentId, FxAccent> = {
  red: { id: "red", label: "Rouge", swatch: "#dc2626", accent: "#dc2626", accentStrong: "#b91c1c", accentSoft: "#fee2e2", accentSoftDark: "#3f1515" },
  orange: { id: "orange", label: "Orange", swatch: "#ea580c", accent: "#ea580c", accentStrong: "#c2410c", accentSoft: "#ffedd5", accentSoftDark: "#3b1c0c" },
  yellow: { id: "yellow", label: "Jaune", swatch: "#ca8a04", accent: "#ca8a04", accentStrong: "#a16207", accentSoft: "#fef9c3", accentSoftDark: "#3f3310" },
  green: { id: "green", label: "Vert", swatch: "#16a34a", accent: "#16a34a", accentStrong: "#15803d", accentSoft: "#dcfce7", accentSoftDark: "#12301c" },
  blue: { id: "blue", label: "Bleu Aurélia", swatch: "#71baff", accent: "#3b82f6", accentStrong: "#2563eb", accentSoft: "#dbeafe", accentSoftDark: "#15233d" },
  purple: { id: "purple", label: "Violet", swatch: "#7c3aed", accent: "#7c3aed", accentStrong: "#6d28d9", accentSoft: "#ede9fe", accentSoftDark: "#26154a" },
  pink: { id: "pink", label: "Rose", swatch: "#db2777", accent: "#db2777", accentStrong: "#be185d", accentSoft: "#fce7f3", accentSoftDark: "#3b1228" },
  slate: { id: "slate", label: "Gris", swatch: "#475569", accent: "#475569", accentStrong: "#334155", accentSoft: "#e2e8f0", accentSoftDark: "#1e293b" },
  teal: { id: "teal", label: "Turquoise", swatch: "#0d9488", accent: "#0d9488", accentStrong: "#0f766e", accentSoft: "#e4f0ed", accentSoftDark: "#10302c" },
  indigo: { id: "indigo", label: "Indigo", swatch: "#4f46e5", accent: "#4f46e5", accentStrong: "#4338ca", accentSoft: "#e0e7ff", accentSoftDark: "#1e1b4b" },
  fuchsia: { id: "fuchsia", label: "Fuchsia", swatch: "#c026d3", accent: "#c026d3", accentStrong: "#a21caf", accentSoft: "#fae8ff", accentSoftDark: "#3b1142" },
  lime: { id: "lime", label: "Citron", swatch: "#84cc16", accent: "#65a30d", accentStrong: "#4d7c0f", accentSoft: "#ecfccb", accentSoftDark: "#243010" },
};

export function normalizeAccent(v: string | null | undefined): FxAccentId {
  if (v && (FX_ACCENT_IDS as readonly string[]).includes(v)) return v as FxAccentId;
  return "teal";
}
